__turbopack_context__.v({
  "chevron": "PlasmicFaqItem-module__O66-mG__chevron",
  "chevronopen": "PlasmicFaqItem-module__O66-mG__chevronopen",
  "freeBox__ha2Mb": "PlasmicFaqItem-module__O66-mG__freeBox__ha2Mb",
  "freeBox__qLyas": "PlasmicFaqItem-module__O66-mG__freeBox__qLyas",
  "freeBox__v3Pvt": "PlasmicFaqItem-module__O66-mG__freeBox__v3Pvt",
  "freeBox__vdDn3": "PlasmicFaqItem-module__O66-mG__freeBox__vdDn3",
  "freeBox__z4Ymq": "PlasmicFaqItem-module__O66-mG__freeBox__z4Ymq",
  "freeBoxopen__qLyasVSmj": "PlasmicFaqItem-module__O66-mG__freeBoxopen__qLyasVSmj",
  "freeBoxopen__v3PvtVSmj": "PlasmicFaqItem-module__O66-mG__freeBoxopen__v3PvtVSmj",
  "freeBoxopen__z4YmqVSmj": "PlasmicFaqItem-module__O66-mG__freeBoxopen__z4YmqVSmj",
  "h1": "PlasmicFaqItem-module__O66-mG__h1",
  "root": "PlasmicFaqItem-module__O66-mG__root",
  "slotTargetChildren": "PlasmicFaqItem-module__O66-mG__slotTargetChildren",
  "slotTargetSlot": "PlasmicFaqItem-module__O66-mG__slotTargetSlot",
  "slotTargetSlotopen": "PlasmicFaqItem-module__O66-mG__slotTargetSlotopen",
});
